import axiosInstance from '../axiosInstance';

export const fetchTiposServiciosProjecto = async () => {
  const response = await axiosInstance.get('/administration/service-types-project');
  return response.data;
};

export const createTipoServicioProjecto = async (data) => {
  const response = await axiosInstance.post('/administration/service-types-project', data);
  return response.data;
};

export const updateTipoServicioProjecto = async (id, data) => {
  const response = await axiosInstance.put(`/administration/service-types-project/${id}`, data);
  return response.data;
};

export const deleteTipoServicioProjecto = async (id) => {
  const response = await axiosInstance.delete(`/administration/service-types-project/${id}`);
  return response.data;
};